import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { __decorate } from "tslib";
import { provide } from 'intact-vue-next';
import template from './index.vdt';
import { DATEPICKER } from './constants';
import dayjs from './dayjs';
import { useValue } from './useValue';
import { isNullOrUndefined } from 'intact-shared';
import { _$ } from '../../i18n';
import { bind } from '../utils';
import { useDisabled } from './useDisabled';
import { useFormats } from './useFormats';
import { usePanel } from './usePanel';
import { useFocusDate } from './useFocusDate';
import { useKeyboards } from './useKeyboards';
import { BasePicker } from './basepicker';
import * as _shortcuts from './shortcuts';
export { _shortcuts as shortcuts };
export { dayjs };
var typeDefs = _extends({}, BasePicker.typeDefs, {
  type: ['date', 'datetime', 'year', 'month'],
  shortcuts: Array
});
var defaults = function defaults() {
  return _extends({}, BasePicker.defaults(), {
    type: 'date'
  });
};
export var Datepicker = /*#__PURE__*/function (_BasePicker) {
  _inheritsLoose(Datepicker, _BasePicker);
  function Datepicker() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _BasePicker.call.apply(_BasePicker, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.formats = useFormats();
    _this.disabled = useDisabled(_this.formats);
    _this.panel = usePanel();
    _this.focusDate = useFocusDate();
    _this.value = useValue(_this.formats, _this.disabled, _this.panel);
    return _this;
  }
  var _proto = Datepicker.prototype;
  _proto.init = function init() {
    _BasePicker.prototype.init.call(this);
    provide(DATEPICKER, this);
    useKeyboards(this.panel.startRef, this.focusDate.focusDate);
  };
  _proto.getPlaceholder = function getPlaceholder() {
    var _this$get = this.get(),
      placeholder = _this$get.placeholder,
      type = _this$get.type,
      range = _this$get.range;
    if (!isNullOrUndefined(placeholder)) return placeholder;
    switch (type) {
      case 'datetime':
        return range ? _$('开始时间 ~ 结束时间') : _$('请选择日期和时间');
      case 'year':
        return _$('请选择年份');
      case 'month':
        return _$('请选择月份');
      default:
        return range ? _$('开始日期 ~ 结束日期') : _$('请选择日期');
    }
  };
  _proto.getLabel = function getLabel() {
    return this.value.format();
  };
  _proto.clear = function clear(e) {
    _BasePicker.prototype.clear.call(this, e);
    if (this.get('type') === 'datetime') {
      // reset the state to let user re-select
      this.panel.reset();
    }
  };
  _proto.setByShortcut = function setByShortcut(shortcut) {
    var _this$value = this.value,
      setValue = _this$value.setValue,
      convertToDayjs = _this$value.convertToDayjs;
    var _this$get2 = this.get(),
      multiple = _this$get2.multiple;
    setValue(convertToDayjs(shortcut.value())[0], true);
    if (!multiple) {
      this.hide();
    }
  };
  return Datepicker;
}(BasePicker);
Datepicker.template = template;
Datepicker.typeDefs = typeDefs;
Datepicker.defaults = defaults;
__decorate([bind], Datepicker.prototype, "clear", null);
__decorate([bind], Datepicker.prototype, "setByShortcut", null);